"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.createEmbeddedWorkflow = exports.fetchEcommerceWorkflowIds = void 0;

var _of = require("rxjs/observable/of");

var _fromPromise = require("rxjs/observable/fromPromise");

var _mergeMap = require("rxjs/operators/mergeMap");

var _map = require("rxjs/operators/map");

var _catchError = require("rxjs/operators/catchError");

var _startWith = require("rxjs/operators/startWith");

var _reduxObservable = require("redux-observable");

var _actions = require("./actions");

var _actions2 = require("settings-ui-sdk/PortalSettings/actions");

var _selectors = require("./selectors");

var _API = _interopRequireDefault(require("./API"));

var _RequestEpicDescriptor = _interopRequireDefault(require("settings-ui-sdk/RequestEpicDescriptor"));

var _requestEntity = _interopRequireDefault(require("settings-ui-sdk/requestEntity"));

var _RequestStatusTypeFilters = require("settings-ui-sdk/constants/RequestStatusTypeFilters");

var createWorkflow = function createWorkflow($action) {
  return $action.ofType(_actions.EcommerceWorkflowsActionTypes.CREATE_WORKFLOW).pipe((0, _map.map)(function (_ref) {
    var _ref$payload = _ref.payload,
        key = _ref$payload.key,
        value = _ref$payload.value;
    return (0, _actions2.stageAndSavePortalSetting)(key, value);
  }), (0, _startWith.startWith)(_actions2.StageAndSavePortalSetting.request()));
}; // == Embedded workflows ======================================================


var fetchEcommerceWorkflowIds = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.getWorkflowIds,
  initiatingActionType: _actions.EcommerceWorkflowsActionTypes.FETCH_WORKFLOW_IDS,
  requestStatusSelector: _selectors.getFetchEcommerceWorkflowIdsRequestStatus,
  requestStatusTypeFilters: _RequestStatusTypeFilters.ALLOW_ONCE,
  requestActions: _actions.FetchEcommerceWorkflowIds
}));
exports.fetchEcommerceWorkflowIds = fetchEcommerceWorkflowIds;

var createEmbeddedWorkflow = function createEmbeddedWorkflow($action) {
  return $action.ofType(_actions.EcommerceWorkflowsActionTypes.CREATE_EMBEDDED_WORKFLOW).pipe((0, _mergeMap.mergeMap)(function (action) {
    var _action$payload$data = action.payload.data,
        emailType = _action$payload$data.emailType,
        refreshFlowCallback = _action$payload$data.refreshFlowCallback;
    return (0, _fromPromise.fromPromise)(_API.default.createEmbeddedWorkflow(emailType)).pipe((0, _map.map)(function (response) {
      refreshFlowCallback();
      return _actions.CreateEmbeddedWorkflow.success(response);
    }), (0, _catchError.catchError)(function (error) {
      return (0, _of.of)(_actions.CreateEmbeddedWorkflow.failure(error));
    }), (0, _startWith.startWith)(_actions.CreateEmbeddedWorkflow.request()));
  }));
};

exports.createEmbeddedWorkflow = createEmbeddedWorkflow;

var _default = (0, _reduxObservable.combineEpics)(createWorkflow, fetchEcommerceWorkflowIds, createEmbeddedWorkflow);

exports.default = _default;